'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RichEditor = require('../RichEditor');

var _RichEditor2 = _interopRequireDefault(_RichEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionBlock = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SectionBlock, _Component);

  function SectionBlock(props) {
    (0, _classCallCheck3.default)(this, SectionBlock);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SectionBlock.__proto__ || (0, _getPrototypeOf2.default)(SectionBlock)).call(this, props));

    console.log(props);
    return _this;
  }

  (0, _createClass3.default)(SectionBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          contentState = _props.contentState,
          block = _props.block;

      var sectionType = contentState.getEntity(block.getEntityAt(0)).data.type;
      var styles = require('./ImageComponent.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { className: 'mask', onClick: this.props.blockProps.parent.setEditable.bind() }),
        _react2.default.createElement(
          'div',
          { className: styles.imageWrapper },
          _react2.default.createElement(
            'span',
            null,
            sectionType
          ),
          _react2.default.createElement(_RichEditor2.default, { parent: this.props.blockProps.parent, forceReadOnly: true })
        )
      );
    }
  }]);
  return SectionBlock;
}(_react.Component), _class.propTypes = {
  block: _react.PropTypes.object,
  contentState: _react.PropTypes.object,
  blockProps: _react.PropTypes.object
}, _temp);
exports.default = SectionBlock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/components/SectionBlock.js
// module id = 1185
// module chunks = 0